export enum RenewalEnum {
  ChangeCar = 'Zmiana auta',
  ChangeCarValue = 'change_car',
  ChangeInformation = 'Zmień informacje ',
  DifferentDate = 'Inny termin ubezpieczenia',
  DifferentDateValue = 'different_date',
  DontHaveACar = 'Nie masz samochodu?',
  FillNewData = 'Uzupełnij dane o nowym aucie',
  Info = 'Wprowadzając dane o Twoim nowym aucie, przedstawimy Ci w przyszłości ofertę ubezpieczenia, dzięki której oszczędzisz nawet do 70%! Z Mubi nie przepłacisz!',
  InfoTitle = 'Dlaczego warto podać te dane?',
  NewCar = 'Mam nowy samochód',
  NewCarValue = 'new_car',
  NoHaveAnyCar = 'Nie mam żadnego auta',
  NoHaveAnyCarValue = 'no_any_car',
  StopNotification = 'Zatrzymaj powiadomienia',
  UpdateCar = 'Zaktualizuj mój samochód',
  UpdateDate = 'Zaktualizuj datę ubezpieczenia',
  UpdateInformation = 'Zaktualizuj informacje ',
  UpdateInformationMore = 'dotyczące',
  WhyYouWantToChange = 'Dlaczego chcesz zmienić dane?',
  YouHaveNewCar = 'Masz nowy samochód?',
}
